<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Uwaga !</h4>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger text-center" role="alert">
            <h4 class="no-margin-top">
              W systemie znajdują się faktury niewysłane do KSeF
            </h4>
            <p>
              Ilość niewysłanych faktur:
              <strong class="unsent-count">{{ count }}</strong>
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" @click="goToInvoices" class="btn btn-primary">
            Przejdź do faktur
          </button>
          <button type="button" @click="modalClose" class="btn btn-default">
            Anuluj
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop"></div>
</template>

<script>
import router from "../../router/router";

export default {
  name: "KsefUnsentInvoicesModal",
  props: {
    count: Number,
  },
  setup(props, context) {
    const modalClose = () => {
      context.emit("callbackClose");
    };

    const goToInvoices = () => {
      context.emit("callbackClose");
      router.push("/invoices/list");
    };

    return {
      modalClose,
      goToInvoices,
    };
  },
};
</script>

<style scoped>
.no-margin-top {
  margin-top: 0;
}
.unsent-count {
  font-size: 18px;
}
</style>
